import { Injectable } from '@angular/core';
import {
  RECEIVERETURNCART,
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  RECEIVESTOCKLOCATION, REFERENCE
} from '../providers/data';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
@Injectable()
export class ReceiveReturncartManager {



  public getCust:any ;
  constructor(private storage:Storage,private sanitizer:DomSanitizer){

  }



  setCustomer(customer){

    if(RECEIVERETURNCART.customer == null){

      RECEIVERETURNCART.customer = customer;
    }else{
      this.clearCartProducts();
      RECEIVERETURNCART.customer = customer;
    }
  }

  setReference(reference){
    REFERENCE.productsreference = reference;
  }

  setLocation(location){
    RECEIVESTOCKLOCATION.productsLocation = location;
  }

// setSalesPerson(user){
//   RECEIVERETURNCART.user = user;
// }

  clearCart(){
    RECEIVERETURNCART.items = [];
  }


  addToCartNew(product) {
    if(!Number(product.quantity)){
      // if(Number(product.quantity)<=1){
      product.quantity = 0;
      // }
    }

    RECEIVERETURNCART.items.push(product);
    this.persistOrderLocal();

// }
  }
  addProductToCart(product) {
    console.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC " + product.cartId);
    var index= RECEIVERETURNCART.items.map(function(x) {return x.cartId; }).indexOf(product.cartId);
    if (index != -1) {
      RECEIVERETURNCART.items[index].quantity++;
      this.persistOrderLocal();
    } else {
      if (Number(product.quantity) != 0) {
        product.quantity = Number(product.quantity);
      } else {
        product.quantity = 0;
      }
      this.addToCartNew(product);
    }
    //alert(JSON.stringify(RECEIVERETURNCART));
  }

  addProductToCartPopup(product) {

    product.quantity++;
    this.persistOrderLocal();
    // } else {
    if (Number(product.quantity) != 0) {
      product.quantity = Number(product.quantity);
    } else {
      product.quantity = 0;
    }
  }

  // update Cart
  updateCartNew(product) {
    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }
      }
    }


    var index= RECEIVERETURNCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
    } else {

      this.addToCartNew(product);
    }
    this.persistOrderLocal();
  }

  updateCartNewPopup(product) {


    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }
      }
    }


    var index= RECEIVERETURNCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
    } else {
    }
    this.persistOrderLocal();
  }
  // Remove One
  removeOneNew(product) {

    product.quantity--;

  }

  // removeOneNewPopup(product) {
  //   var index= RECEIVERETURNCART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //   if (index != -1) {
  //     // if(RECEIVERETURNCART.items[index].quantity > Number(product.minOrder)){
  //     RECEIVERETURNCART.items[index].quantity--;
  //     this.persistOrderLocal();
  //
  //
  //   }
  // }

  // Remove All
  removeAll(product) {
    var index= RECEIVERETURNCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(RECEIVERETURNCART.items[index].quantity >= 1){
        RECEIVERETURNCART.items[index].quantity = 0;
      }
    }
    this.persistOrderLocal();
  }


  // Remove Item
  removeNew(index: number): void {

    RECEIVERETURNCART.items.splice(index, 1);
    this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    // this.removeAll(product);
    var index= RECEIVERETURNCART.items.map(function(x) {return x.cartId; }).indexOf(product.cartId);
    if (index != -1) {
      this.removeNew(index);
    }
  }

  genrateOrder(status){
    //alert(JSON.stringify(RECEIVERETURNCART));
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = RECEIVERETURNCART.shipDate;
    for(let item of RECEIVERETURNCART.items){

      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };

      orderProducts.push(orderDetailDTOs);
    }

    if(RECEIVERETURNCART.customer.locationsDTOs.length>0){
      for(let locationId in RECEIVERETURNCART.customer.locationsDTO){
        RECEIVERETURNCART.customer.locationsDTO[locationId].createdAt = "";
        RECEIVERETURNCART.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    RECEIVERETURNCART.customer.customerJson = "";

    let order = {
      "id":RECEIVERETURNCART.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":RECEIVERETURNCART.user.id,
      "orderMessage":RECEIVERETURNCART.orderMessage,
      "expectedShipmentDate": RECEIVERETURNCART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":RECEIVERETURNCART.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":RECEIVERETURNCART.shippingServiceName,
      "shippingServiceValue":RECEIVERETURNCART.shippingServiceId
    };
    return order;

  }

  receiveStock(status, reference, productLocation){
    //alert(JSON.stringify(RECEIVERETURNCART));
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = RECEIVERETURNCART.shipDate;
    for(let item of RECEIVERETURNCART.items){

      console.log("BBBBBBBBBBBBBBBBBBBBBBB " + item.badProductDtoList);
      if(item.badProductDtoList !== undefined){
        let total = 0;
        for(let badPro of item.badProductDtoList){
          total += badPro.quantity;
        }
        item.quantity = item.quantity-total;
      }


      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      item.quantity = item.quantity;

      item.referenceNumber = reference;
      item.locationCode = productLocation;


      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch,
      };
      orderProducts.push(orderDetailDTOs);
    }
    // RECEIVERETURNCART.customer.customerJson = "";


    let order = {
      "id":RECEIVERETURNCART.orderId,
      "barCode":RECEIVERETURNCART.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":RECEIVERETURNCART.user.id,
      "orderMessage":RECEIVERETURNCART.orderMessage,
      "expectedShipmentDate": RECEIVERETURNCART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":RECEIVERETURNCART.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":RECEIVERETURNCART.shippingServiceName,
      "shippingServiceValue":RECEIVERETURNCART.shippingServiceId
    };

    return order;

  }

  clearCartProducts(){
    for(let product of RECEIVERETURNCART.items){
      this.removeAll(product);
    }
    RECEIVERETURNCART.items = [];
  }

  getProductsCount(){
    return RECEIVERETURNCART.items.length;
  }

  getSalesManId(){
    return RECEIVERETURNCART.user.id;
  }
  getCustomerName(){
    if(RECEIVERETURNCART.customer !=null){

      return RECEIVERETURNCART.customer.name;
    }else{
      return null;
    }
  }

  getSalesPerson(){
    return RECEIVERETURNCART.user;

  }

  getADPCustomerUUID(){
    if(RECEIVERETURNCART.user && RECEIVERETURNCART.user.adpCustomerInfo){
      return RECEIVERETURNCART.user.adpCustomerInfo.uuid;
    }else{
      return "";
    }
  }

  setShipDate(shipDate){
    RECEIVERETURNCART.expectedShipmentDate = shipDate ;
  }
  // getShipDate(){
  //   return RECEIVERETURNCART.expectedShipmentDate;
  // }

  // setOdId(odId){
  //   RECEIVERETURNCART.odId = odId;
  // }

  // getOdId(){
  //   return RECEIVERETURNCART.odId;
  // }

  // setItems(productsList){
  //   RECEIVERETURNCART.items = productsList;
  // }
  setOrderId(orderId){
    RECEIVERETURNCART.orderId = orderId ;
  }
  setOrderMessage(orderMessage){
    RECEIVERETURNCART.orderMessage = orderMessage;
  }
  // getOrderMessage(){
  //  return RECEIVERETURNCART.orderMessage;
  // }

  // getExpectedSipDate(){
  //   return RECEIVERETURNCART.expectedSipDate;
  // }

  getItems(){
    return RECEIVERETURNCART.items;
  }


  getCustomerID(){
    if(RECEIVERETURNCART.customer!=null){
      return RECEIVERETURNCART.customer.id;
    }else{
      return false;
    }
  }


  // getSelectedCustomer(){
  //     return RECEIVERETURNCART.customer;
  // }

  setOrderTitle(orderTitle){
    RECEIVERETURNCART.orderTitle = orderTitle;
  }

  getOrderTitle(){
    return RECEIVERETURNCART.orderTitle;
  }
  getOrderId(){
    return RECEIVERETURNCART.orderId;
  }

  persistOrderLocal(){
    // TODO: Store the list of Cart against their user/sales persons
    let itemQuantityStatus = false;
    for(let product of RECEIVERETURNCART.items){
      if(product.quantity > 0){
        itemQuantityStatus = true;
        break;
      }
    }

    if(Number(RECEIVERETURNCART.items.length) > 0 && itemQuantityStatus){
      this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),RECEIVERETURNCART);

    }else{
      this.unPersistOrderLocal();
    }
//this.gVLogger.log(RECEIVERETURNCART);
  }
  unPersistOrderLocal(){
    this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());


  }

// getPersistedOrderLocal(){
//
//   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
// }

// setCartFull(cartTemp){
//    RECEIVERETURNCART.items = cartTemp.items;
//    RECEIVERETURNCART.orderId = cartTemp.orderId;
//    RECEIVERETURNCART.orderMessage = cartTemp.orderMessage;
//    RECEIVERETURNCART.customer = cartTemp.customer;
//    RECEIVERETURNCART.orderTitle = cartTemp.orderTitle;
//   // this.gVLogger.log("Cart Replaced...",cartTemp);
// }


  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  getOrderStatus(){
    return RECEIVERETURNCART.orderStatus;
  }

  setOrderStatus(status){
    RECEIVERETURNCART.orderStatus = status;
  }


// removeJunkFromCart(){
//   for(let item of RECEIVERETURNCART.items ){
//
//     if(item.quantity == 0 || item.quantity == '0'){
//
//       var index= RECEIVERETURNCART.items.map(function(x) {return x.id; }).indexOf(item.id);
//       if (index != -1) {
//           if(RECEIVERETURNCART.items[index].quantity >= 1){
//             RECEIVERETURNCART.items[index].quantity = 0;
//           }
//           RECEIVERETURNCART.items.splice(index, 1);
//         }
//     }
//   }
// }


  makeImageURL(dimensions,item){
    return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getADPCustomerUUID() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension;
  }


// setShippingServiceId(id){
//   RECEIVERETURNCART.shippingServiceId = id;
// }
// getShippingServiceId(){
// return RECEIVERETURNCART.shippingServiceId;
// }


// setAdpCustomerInfo(adpCustomerInfo){
//   AdpCustomer.AdpCustomerInfo = adpCustomerInfo;
// }

  getAdpCustomerInfo(){
    return AdpCustomer.AdpCustomerInfo;
  }


// sanitizeUrl(url){
//   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
//   }
//
//
//
//   addToAttributeMap(key,value){
//     attributesMap[key+""] = ""+value;
//   }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  // addAttributePropertiesMap(key,val){
  //   attributesPropertiesMap.set(key+"", val);
  // }
  //
  // getAllAttributesPropertiesMap(){
  //   return attributesPropertiesMap;
  // }

  replaceDoublePipe(str){
    return str.split("||").join(" ");
  }

  ConvertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') line += ',';
        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/receive-returncart-manager.ts